// material
import { styled } from '@mui/material/styles';
import { Box, Stack, Container, Typography } from '@mui/material';
// layouts
import Page from '../../components/Page';
import { LoginForm } from '../../components/authentication/login';
import { appName } from 'config';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function Login() {
  return (
    <RootStyle title={`Авторизация | ${appName}`}>
      <Container maxWidth="sm">
        <ContentStyle>
          <Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="h4" gutterBottom>
                {`Авторизуйтесь в ${appName}`}
              </Typography>
              <Typography sx={{ color: 'text.secondary' }}>Введите ваши данные ниже:</Typography>
            </Box>
          </Stack>
          <LoginForm />
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
